/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type ReceiptResponse,
    ReceiptResponseFromJSON,
    ReceiptResponseToJSON,
} from '../models/ReceiptResponse';

export interface GetReceipt1Request {
    paymentReference: string;
}

/**
 * 
 */
export class NetsReceiptControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for getReceipt1 without sending the request
     */
    async getReceipt1RequestOpts(requestParameters: GetReceipt1Request): Promise<runtime.RequestOpts> {
        if (requestParameters['paymentReference'] == null) {
            throw new runtime.RequiredError(
                'paymentReference',
                'Required parameter "paymentReference" was null or undefined when calling getReceipt1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/nets/{paymentReference}/receipt`;
        urlPath = urlPath.replace('{paymentReference}', encodeURIComponent(String(requestParameters['paymentReference'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getReceipt1Raw(requestParameters: GetReceipt1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReceiptResponse>> {
        const requestOptions = await this.getReceipt1RequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReceiptResponseFromJSON(jsonValue));
    }

    /**
     */
    async getReceipt1(requestParameters: GetReceipt1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReceiptResponse> {
        const response = await this.getReceipt1Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
